//@flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';
import type { OutletsDataModelType } from './OutletsData';

export type PlanConfigConstantsModelType = {
    revenueFairness: boolean,
    tatFairness: boolean,
    outletNumberFairness: boolean,
    minTerritory: number,
    maxTerritory: number
};

export type CreateTerritoryConfigModelType = {
    clientId: string,
    name: string,
    configuration: PlanConfigConstantsModelType,
    outletsData: OutletsDataModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class PlanConfigConstants extends ImmutableModel {
    static fromJS(json: PlanConfigConstantsModelType): PlanConfigConstants {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): PlanConfigConstantsModelType {
        return {
            revenueFairness: this.revenueFairness,
            tatFairness: this.tatFairness,
            outletNumberFairness: this.outletNumberFairness,
            minTerritory: this.minTerritory,
            maxTerritory: this.maxTerritory
        };
    }

    get revenueFairness(): boolean {
        return this._state.get('revenueFairness');
    }

    setRevenueFairness(revenueFairness: boolean): this {
        return this.clone(this._state.set('revenueFairness', revenueFairness));
    }

    get tatFairness(): boolean {
        return this._state.get('tatFairness');
    }

    setTatFairness(tatFairness: boolean): this {
        return this.clone(this._state.set('tatFairness', tatFairness));
    }

    get outletNumberFairness(): boolean {
        return this._state.get('outletNumberFairness');
    }

    setOutletNumberFairness(outletNumberFairness: boolean): this {
        return this.clone(
            this._state.set('outletNumberFairness', outletNumberFairness)
        );
    }

    get minTerritory(): number {
        return this._state.get('minTerritory');
    }

    setMinTerritory(minTerritory: number): this {
        return this.clone(this._state.set('minTerritory', minTerritory));
    }

    get maxTerritory(): number {
        return this._state.get('maxTerritory');
    }

    setMaxTerritory(maxTerritory: number): this {
        return this.clone(this._state.set('maxTerritory', maxTerritory));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class CreateTerritoryConfig extends ImmutableModel {
    static fromJS(json: CreateTerritoryConfigModelType): CreateTerritoryConfig {
        const state: Object = Object.assign({}, json);
        state.configuration = PlanConfigConstants.fromJS(state.configuration);
        state.outletsData = OutletsData.fromJS(state.outletsData);
        return new this(Immutable.Map(state));
    }

    toJS(): CreateTerritoryConfigModelType {
        return {
            clientId: this.clientId,
            name: this.name,
            configuration: this.configuration.toJS(),
            outletsData: this.outletsData.toJS()
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get configuration(): PlanConfigConstants {
        return this._state.get('configuration');
    }

    setConfiguration(configuration: PlanConfigConstants): this {
        return this.clone(this._state.set('configuration', configuration));
    }

    get outletsData(): OutletsData {
        return this._state.get('outletsData');
    }

    setOutletsData(outletsData: OutletsData): this {
        return this.clone(this._state.set('outletsData', outletsData));
    }
}
